module.exports = __webpack_public_path__ + "img/cancun-bay-pool-6.ffc86e12.jpg";